import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";
import BarcodeScannerComponent from "react-webcam-barcode-scanner";
import "reactjs-popup/dist/index.css";
import { getProductInfo, setProductInfo } from "../../services/scanner/actions";
import "./Scanner.scss";

const usePropChangeEffect = (func, deps) => {
  const didMount = useRef(false);
  useEffect(() => {
    if (didMount.current) func();
    else didMount.current = true;
    // eslint-disable-next-line
  }, deps);
};

function scannerComponent(props) {
  const [currentLocation, setCurrentLocation] = React.useState(
    props.currentLocation
  );
  const [data, setData] = React.useState("Not Found");
  const [productInfoDetails, setProductInfoDetails] = React.useState([]);
  const [togglePopup, setTogglePopup] = React.useState(false);
  const [inventoryAmount, setInventoryAmount] = React.useState(null);
  const [packagesAmount, setPackagesAmount] = React.useState(null);

  const createPopUp = () => {
    return (
      <div className="popup">
        <h2>Product: {productInfoDetails.name}</h2>
        <h2>Verpakking: {productInfoDetails.package}</h2>

        <h3>Aantal losse stuks:</h3>

        <input
          onChange={(e) => setInventoryAmount(e.target.value)}
          placeholder="Aantal"
          required
          autoFocus
          type="number"
          min="0"
          max="10000"
        ></input>
        <h3>Aantal verpakkingen:</h3>
        <input
          onChange={(e) => setPackagesAmount(e.target.value)}
          placeholder="Aantal"
          required
          autoFocus
          type="number"
          min="0"
          max="10000"
        ></input>
        <br />
        <br />

        <button
          onClick={() =>
            setProductInfo(
              productInfoDetails.product_id,
              inventoryAmount,
              packagesAmount,
              currentLocation.id,
              setTogglePopup
            )
          }
        >
          Bewaar
        </button>
        <button onClick={() => setTogglePopup(false)}>Ga terug</button>
      </div>
    );
  };

  usePropChangeEffect(() => {
    setCurrentLocation(props.currentLocation);
  }, [props.currentLocation]);

  useEffect(() => {
    if (togglePopup == true) {
      getProductInfo(data, setProductInfoDetails);
    }
  }, [togglePopup]);

  return (
    <>
      {togglePopup ? null : (
        <BarcodeScannerComponent
          width={"100%"}
          height={"100%"}
          className={"scanner"}
          onUpdate={(err, result) => {
            if (result) {
              setData(result.text);
              setTogglePopup(true);
            }
          }}
        />
      )}
      {togglePopup ? createPopUp() : null}
    </>
  );
}

function mapStateToProps(state) {
  return {
    currentLocation: state.currentInformation.current_location,
  };
}

export default connect(mapStateToProps)(scannerComponent);
